import { clsx } from "clsx";
import React from "react";
import { ReactNode } from "react";

export function DetailRow({ label, value }: { label: string; value?: string | ReactNode }) {
  return (
    <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4">
      <dt className="text-sm/6 font-medium text-etpink-600">{label}</dt>
      <dd className={clsx("mt-1 text-sm/6 sm:col-span-2 sm:mt-0 ml-4", value ? "text-gray-700" : "text-gray-500 italic")}>{value ?? "N/A"}</dd>
    </div>
  );
}